import React from 'react';
import PropTypes from 'prop-types';
import { isServer } from '../../../../modules/serverCheck';
import styles from './styles.scss';

const propTypes = {
  scrolling: PropTypes.string.isRequired,
  style: PropTypes.shape({
    border: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  title: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
};

const defaultProps = {
  style: {},
};

const EmbedVideo = ({
  scrolling,
  style,
  title,
  src,
  ...rest
}) => {
  const url = new URL(src);
  const isYoutube = url.hostname.includes('youtube');
  const videoStyles = { border: 'none', width: '100%', objectFit: 'contain', ...style };

  if (isServer() && !isYoutube) {
    return <div style={videoStyles} />;
  }

  // if video is not from youtube, loading the preview image will be broken
  // so we just bypass that and just load the iframe
  if (!isYoutube) {
    return (
      <div className={styles.container}>
        <iframe
          src={src}
          style={videoStyles}
          scrolling={scrolling}
          title={title}
          {...rest}
        />
      </div>
    );
  }

  const parsedUrl = url.pathname.split('/');
  const videoId = parsedUrl[parsedUrl.length - 1];

  const previewImage = `https://img.youtube.com/vi/${videoId}/sddefault.jpg`;

  if (!url.searchParams.has('autoplay')) {
    url.searchParams.append('autoplay', 1);
  }

  const srcDoc = `
    <style>
      *{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}
    </style>
    <a
      href=${url.href}
    >
      <img
        src=${previewImage}
        alt=${title}
        loading="lazy"
      />
      <span>&#9658;</span>
    </a>
  `;

  return (
    <div className={styles.container}>
      <iframe
        src={src}
        srcDoc={srcDoc}
        style={videoStyles}
        scrolling={scrolling}
        title={title}
        {...rest}
      />
    </div>
  );
};

EmbedVideo.propTypes = propTypes;
EmbedVideo.defaultProps = defaultProps;

export default EmbedVideo;
